import { Component } from 'opus-angular-seed-core';

@Component({
    template: `
    <div class="heading01 type01">
        <h1>{{ 'user.Competences' | translate }}</h1>
        <ul class="actions01">
            <li><a class="btn add" ui-sref="authorized.user.competence.competence.add()">{{ 'user.Add competence' | translate }}</a></li>
        </ul>
    </div>
    <list-factory-empty list="vm.list" show-add-message="true"></list-factory-empty>
    <table class="data01" datatable dt-options="vm.DATATABLES" ng-if="vm.list.items.length && !vm.loading">
        <thead>
        <tr>
            <th ng-class="vm.list.getSortClass('name')"><a ng-click="vm.list.sortBy('name')">{{ 'user.Name' | translate }}</a></th>
            <th>{{ 'user.Skills' | translate }}</th>
            <th class="actions nosort">&nbsp;</th>
        </tr>
        </thead>
        <tbody>
            <tr ng-repeat="competence in vm.list.items">
                <td><a ui-sref="authorized.user.competence.competence.view({ id: competence.id })">{{ competence.name }}</a></td>
                <td>{{ competence.skillCount }}</td>
                <td class="actions">
                    <a ui-sref="authorized.user.competence.competence.view({ id: competence.id })" class="btn edit">{{ 'general.Edit' | translate }}</a>
                </td>
            </tr>
        </tbody>
    </table>
    <pagination list="vm.list"></pagination>
`
})
export default class {
    constructor (CompetenceResource, ListFactory, DATATABLES) {
        this.CompetenceResource = CompetenceResource;
        this.ListFactory = ListFactory;
        this.DATATABLES = DATATABLES;
    }

    $onInit () {
        this.list = this.ListFactory.createWithPagination(this.CompetenceResource.query.bind(this.CompetenceResource));
        this.list.fetch();
    }
}



// WEBPACK FOOTER //
// ./src/app/components/user/competence/competence/list/index.js